/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Oid from './Oid';

/**
 * The AsnEncodedData model module.
 * @module model/AsnEncodedData
 * @version V1
 */
class AsnEncodedData {
    /**
     * Constructs a new <code>AsnEncodedData</code>.
     * @alias module:model/AsnEncodedData
     */
    constructor() { 
        
        AsnEncodedData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AsnEncodedData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AsnEncodedData} obj Optional instance to populate.
     * @return {module:model/AsnEncodedData} The populated <code>AsnEncodedData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AsnEncodedData();

            if (data.hasOwnProperty('oid')) {
                obj['oid'] = Oid.constructFromObject(data['oid']);
            }
            if (data.hasOwnProperty('rawData')) {
                obj['rawData'] = ApiClient.convertToType(data['rawData'], 'Blob');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AsnEncodedData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AsnEncodedData</code>.
     */
    static validateJSON(data) {
        // validate the optional field `oid`
        if (data['oid']) { // data not null
          Oid.validateJSON(data['oid']);
        }

        return true;
    }


}



/**
 * @member {module:model/Oid} oid
 */
AsnEncodedData.prototype['oid'] = undefined;

/**
 * @member {Blob} rawData
 */
AsnEncodedData.prototype['rawData'] = undefined;






export default AsnEncodedData;

